import { useEffect, useState } from "react";

/** Current time, re-rendering every `intervalMs`. */
export function useNow(intervalMs = 1000) {
  const [now, setNow] = useState(() => new Date());
  useEffect(() => {
    const id = window.setInterval(() => setNow(new Date()), intervalMs);
    return () => window.clearInterval(id);
  }, [intervalMs]);
  return now;
}

export const pad2 = (n: number) => String(n).padStart(2, "0");

/** "BST" / "GMT" style short zone name for the given date. */
export function shortZone(d: Date) {
  return (
    new Intl.DateTimeFormat("en-GB", { timeZoneName: "short" })
      .formatToParts(d)
      .find((p) => p.type === "timeZoneName")?.value ?? ""
  );
}
